var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.757812 30.5C0.757812 13.8491 14.256 0.35083 30.907 0.35083C47.5579 0.35083 61.0561 13.8491 61.0561 30.5C61.0561 47.1509 47.5579 60.6491 30.907 60.6491C14.256 60.6491 0.757812 47.1509 0.757812 30.5Z",
    fill: "#FFE1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9314 33.4998C23.4167 33.5624 17.3388 38.6531 17.3905 44.8629C17.394 45.2829 17.7267 45.6101 18.1467 45.6066L43.9158 45.3922C44.3358 45.3887 44.663 45.056 44.6595 44.636C44.6079 38.4262 38.4461 33.4373 30.9314 33.4998Z",
    fill: "#E31F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1039 21.1397C37.9178 20.4062 37.6118 19.6888 37.1863 19.0323C36.8974 18.5547 36.5184 18.0778 36.1099 17.6612C34.7487 16.3225 32.9877 15.6021 31.187 15.5271C29.1459 15.4091 27.0672 16.1764 25.5053 17.7494C24.0326 19.2317 23.2989 21.2029 23.3454 23.1826C23.376 25.0574 24.1416 26.9261 25.5785 28.3542C26.5767 29.3359 27.7972 29.9858 29.1046 30.2749C29.8111 30.4491 30.5618 30.5328 31.3113 30.4666C33.0956 30.3767 34.8297 29.6573 36.1831 28.266C38.102 26.3149 38.7394 23.5945 38.1039 21.1397ZM33.869 25.9751C33.3335 26.5196 32.4335 26.5271 31.8891 25.9916L30.8455 24.9653L29.8638 25.9635C29.3283 26.5079 28.4283 26.5154 27.8838 25.9799C27.3242 25.4296 27.3169 24.5446 27.8524 24.0001L28.8341 23.0019L27.8664 22.0799C27.3218 21.5295 27.3144 20.6445 27.8497 20.07C28.4001 19.5254 29.2851 19.518 29.8596 20.0533L30.7975 21.0055L31.7941 19.9922C32.3296 19.4477 33.2146 19.4403 33.7741 19.9757C34.3186 20.5112 34.326 21.4112 33.7906 21.9556L32.8088 22.9538L33.8525 23.9952C34.397 24.5307 34.4045 25.4307 33.869 25.9751Z",
    fill: "#E31F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateIcon);
export default __webpack_public_path__ + "static/media/deactivateIcon.c271bf966c4cbe874e7df99bb7742c4f.svg";
export { ForwardRef as ReactComponent };